<div class="container row">
  <app-config-line
    [title]="'Preferencias panel de conductores'"
    [titleLevel]="7"
    [withHr]="false"
    [sectionReturn]="configSections.VIEWS_PREFERENCES"
    [render]="!filterOptionsBy"
  >
  </app-config-line>

  <app-config-line
    [title]="'Columnas de la tabla'"
    [description]="'Selecciona las columnas que deseas mostrar en la tabla de conductores'"
    [filterBy]="filterOptionsBy"
  >
    <p-multiSelect
      [options]="columnOptions"
      [(ngModel)]="selectedColumns"
      defaultLabel="Seleccionar columnas"
      [showToggleAll]="false"
      [appendTo]="'body'"
      [selectedItemsLabel]="'{0} columnas seleccionadas'"
      (onChange)="updateVisibleColumns()"
      [maxSelectedLabels]="2"
    ></p-multiSelect>
  </app-config-line>


  <app-config-line
    [title]="'Botón para añadir conductor'"
    [description]="'Muestra o oculta la opción de añadir nuevos conductores'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [pTooltip]="'Ocultar/Mostrar'"
        [(ngModel)]="driverService.configuration.addDriver"
      />
      <span class="slider"></span>
    </label>  
  </app-config-line>


  <app-config-line
    [title]="'Enrolamiento de conductores'"
    [description]="'Activa o desactiva la opción para enrolar conductores en el sistema'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [pTooltip]="'Ocultar/Mostrar'"
        [(ngModel)]="driverService.configuration.enrollmentDriver"
      />
      <span class="slider"></span>
    </label>  
  </app-config-line>

</div>
